<script>
    const deviceDPI = {}
    const topbarheight=10
    const article={}
    const tabId = ''
    function enchanceNoBreak() {
      let supList = document.querySelectorAll(".jo-sup");
      for (let i in supList) {
        let node = supList[i]
        let canSplit = true
        while (!node.previousSibling && node.parentNode) {
          node = node.parentNode
          if (node.tagName == "P" || node.tagName == "TD" || node.tagName == "TH" || node.tagName == "DIV") {
            canSplit = false
            break
          }
        }
        if (!canSplit || node.parentNode && node.parentNode.tagName == "NOBR") {
          continue
        }
        if (!node.previousSibling || node.previousSibling.textContent.length == 0) {
          continue
        }
        if (node.previousSibling.className) {
          if (node.previousSibling.className.indexOf("jo-vocab") > -1 ||
            node.previousSibling.className.indexOf("jo-inlineformula") > -1) {
            continue
          }
        }

        if (node.previousSibling.tagName == "NOBR") {
          node.previousSibling.appendChild(node)
        }
        else {
          let splitedNode = node.previousSibling.cloneNode(false)
          if (splitNode(node.previousSibling, splitedNode)) {
            let nobrNode = document.createElement("nobr")
            node.parentNode.insertBefore(nobrNode, node)
            nobrNode.appendChild(splitedNode)
            nobrNode.appendChild(node)
          }
        }
      }
    }
    function splitNode(node, splitedNode) {
      if (node.nodeName === "#text") {
        if (node.textContent.length == 1) {
          splitedNode = node.textContent
          if (node.parentNode.childNodes.length == 1) {
            node.parentNode.parentNode.removeChild(node.parentNode)
          } else {
            node.parentNode.removeChild(node)
          }
          return true
        } else if (node.textContent.length > 1) {
          let lastText = node.textContent.substring(node.textContent.length - 1, node.textContent.length)
          splitedNode.textContent = lastText
          node.textContent = node.textContent.substring(0, node.textContent.length - 1)
          return true
        } else {
          return false;
        }
      } else {
        if (node.childNodes.length > 0) {
          let splitedChildNode = node.lastChild.cloneNode(false)
          splitedNode.appendChild(splitedChildNode)
          return splitNode(node.lastChild, splitedChildNode)
        } else {
          return false
        }
      }
    }
    export default
    {
        deviceDPI,
        topbarheight,
        article,
        tabId,
      enchanceNoBreak
    }
</script>



// WEBPACK FOOTER //
// src/components/Global.vue